import React from "react";
import Classes from "./styles/style.module.css";
import ThemeHandler from "./ThemeHandler";
import NavElement from "./NavElement";
import useGetPath from "../../Hooks/getPath";
// import NotificationHandler from "./NotificationHandler";
import useLocalStorage from "../../Hooks/getLocalStorageData";
import NavUserSection from "./NavUserSection";
import NavUtils from "./NavUtils";
import Loading from "../loadingDialog";
import useHomeAddress from "../../Hooks/getHomeAddress";
import { useSelector } from "react-redux";
import SoundHandler from "./SoundHandler";

const SideNav = (props) => {
  const { user } = useLocalStorage();
  const { path } = useGetPath();
  const { homeAddress } = useHomeAddress();
  const { loadingLogOut } = useSelector(({ user }) => user);

  return (
    <div
      className={`${Classes.sideNavContainer}  ${
        props.open ? Classes.open : Classes.close
      }`}
    >
      <div className={Classes.innerNavContainer}>
        {loadingLogOut ? (
          <div className={Classes.loadingContainer}>
            <Loading className={"d-flex justify-content-center"} size={30} />
          </div>
        ) : (
          <>
            <NavUserSection />
            <div className={Classes.sideNavMiddlePart}>
              {user ? (
                <>
                  {path === "/profile" ? (
                    <NavElement
                      isLink={false}
                      clickHandler={props.sideBarToggler}
                      text={"کاربر"}
                      active={true}
                    />
                  ) : (
                    <NavElement
                      isLink={true}
                      link={"/profile"}
                      text={"کاربر"}
                      active={false}
                    />
                  )}
                </>
              ) : null}
              {path === "/" || path === homeAddress ? (
                <NavElement
                  isLink={false}
                  clickHandler={props.sideBarToggler}
                  text={"خانه"}
                  active={true}
                />
              ) : (
                <NavElement
                  isLink={true}
                  link={homeAddress}
                  text={"خانه"}
                  active={false}
                />
              )}
              {!user ? (
                <NavElement
                  isLink={true}
                  link={"/profile"}
                  text={"ورود به حساب کاربری"}
                />
              ) : null}
              <NavElement
                isLink={true}
                link={"https://eitaa.com/msc_tech"}
                blankLink={true}
                clickHandler={() =>
                  window.open("https://eitaa.com/msc_cul_admin", "_blank")
                }
                text={"پشتیبان امور فرهنگی"}
              />
              <SoundHandler />
              <ThemeHandler />
              {/* <NotificationHandler /> */}
            </div>
          </>
        )}
      </div>
      <NavUtils user={user} />
    </div>
  );
};

export default SideNav;
